var translations = {
	"da-dk": {
	searchPlaceholder: "Søg",
	Products: "Produkter",
	Designs: "Design",
	"Help Center": "Hjælp",
	Inspiration: "Inspiration",
	PersonalizedResults: "Dine design",
	finishEditing: "Afslut redigering",
	reorder: "Genbestil",
	projects: "projekter ({{{ numResults }}})",
	orders: "bestillinger ({{{ numResults }}})",
	seeAll: "Se alle",
	clearLabel: "Ryd",
	searchFlyoutLabel: "Der er {{numberOfResults}} tilgængelige forslag. Brug pil op og ned til at navigere.",
	outOfStock: "Ikke på lager",
	topSearches: "Mest populære søgninger",
	loading: "Indlæser ...",
	yourRelatedProjects: "Dine relaterede {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Dine relaterede {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Dine relaterede {{{projectsAndCountToken}}} og {{{ordersAndCountToken}}}",
	topResults: "Mest populære resultater",
	category: "Kategori",
	exploreAllResults: "Se alle resultater",
	relatedDesigns: "Relaterede design",
	relatedHelpArticles: "Relaterede hjælpeartikler",
	categories: "Kategorier",
	searchResults: "Søgeresultater",
	recentSearches: "Seneste søgninger",
	clearAllRecentSearches: "Ryd alle de seneste søgninger",
	popularSearches: "Populære søgninger",
	suggestedQueries: "Søgeforslag"
},
	"de-de": {
	searchPlaceholder: "Suchen",
	Products: "Produkte",
	Designs: "Designs",
	"Help Center": "Hilfe",
	Inspiration: "Inspiration",
	PersonalizedResults: "Ihre Designs",
	finishEditing: "Fertig bearbeiten",
	reorder: "Nachbestellen",
	projects: "Projekte ({{{ numResults }}})",
	orders: "Bestellungen ({{{ numResults }}})",
	seeAll: "Alle ansehen",
	clearLabel: "Entfernen",
	searchFlyoutLabel: "Es sind {{numberOfResults}} Vorschläge vorhanden. Verwenden Sie die Pfeiltasten zum Navigieren.",
	outOfStock: "Nicht vorrätig",
	topSearches: "Top-Suchen",
	loading: "Wird geladen…",
	yourRelatedProjects: "Ähnliche {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Ähnliche {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Ähnliche {{{projectsAndCountToken}}} und {{{ordersAndCountToken}}}",
	topResults: "Top-Ergebnisse",
	category: "Kategorie",
	exploreAllResults: "Alle Ergebnisse ansehen",
	relatedDesigns: "Ähnliche Designs",
	relatedHelpArticles: "Ähnliche Hilfeartikel",
	categories: "Kategorien",
	searchResults: "Suchergebnisse",
	recentSearches: "Zuletzt durchgeführte Suchen",
	clearAllRecentSearches: "Letzte Suchen löschen",
	popularSearches: "Häufig gesucht",
	suggestedQueries: "Suchvorschläge"
},
	"en-gb": {
	searchPlaceholder: "Search",
	Products: "Products",
	Designs: "Designs",
	"Help Center": "Help Centre",
	Inspiration: "Inspiration",
	PersonalizedResults: "Your designs",
	finishEditing: "Finish editing",
	reorder: "Reorder",
	projects: "projects ({{{ numResults }}})",
	orders: "orders ({{{ numResults }}})",
	seeAll: "See all",
	clearLabel: "Clear",
	searchFlyoutLabel: "There are {{numberOfResults}} suggestions available. Use up and down arrows to navigate.",
	outOfStock: "Out of stock",
	topSearches: "Top Searches",
	loading: "Loading...",
	yourRelatedProjects: "Your related {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Your related {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Your related {{{projectsAndCountToken}}} and {{{ordersAndCountToken}}}",
	topResults: "Top results",
	category: "Category",
	exploreAllResults: "Explore all results",
	relatedDesigns: "Related designs",
	relatedHelpArticles: "Related help articles",
	categories: "Categories",
	searchResults: "Search results",
	recentSearches: "Recent searches",
	clearAllRecentSearches: "Clear all recent",
	popularSearches: "Popular searches",
	suggestedQueries: "Suggested searches"
},
	"en-ie": {
	searchPlaceholder: "Search",
	Products: "Products",
	Designs: "Designs",
	"Help Center": "Help Center",
	Inspiration: "Inspiration",
	PersonalizedResults: "Your designs",
	finishEditing: "Finish editing",
	reorder: "Reorder",
	projects: "projects ({{{ numResults }}})",
	orders: "orders ({{{ numResults }}})",
	seeAll: "See all",
	clearLabel: "Clear",
	searchFlyoutLabel: "There are {{numberOfResults}} suggestions available. Use up and down arrows to navigate.",
	outOfStock: "Out of stock",
	topSearches: "Top Searches",
	loading: "Loading...",
	yourRelatedProjects: "Your related {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Your related {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Your related {{{projectsAndCountToken}}} and {{{ordersAndCountToken}}}",
	topResults: "Top results",
	category: "Category",
	exploreAllResults: "Explore all results",
	relatedDesigns: "Related designs",
	relatedHelpArticles: "Related help articles",
	categories: "Categories",
	searchResults: "Search results",
	recentSearches: "Recent searches",
	clearAllRecentSearches: "Clear all recent",
	popularSearches: "Popular searches",
	suggestedQueries: "Suggested searches"
},
	"en-in": {
	searchPlaceholder: "Search",
	Products: "Products",
	Designs: "Designs",
	"Help Center": "Help Center",
	Inspiration: "Inspiration",
	PersonalizedResults: "Your designs",
	finishEditing: "Finish editing",
	reorder: "Reorder",
	projects: "projects ({{{ numResults }}})",
	orders: "orders ({{{ numResults }}})",
	seeAll: "See all",
	clearLabel: "Clear",
	searchFlyoutLabel: "There may be search suggestions available. Use up and down arrows to navigate.",
	outOfStock: "Out of stock",
	topSearches: "Top Searches",
	loading: "Loading...",
	yourRelatedProjects: "Your related {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Your related {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Your related {{{projectsAndCountToken}}} and {{{ordersAndCountToken}}}",
	topResults: "Top results",
	category: "Category",
	exploreAllResults: "Explore all results",
	relatedDesigns: "Related designs",
	relatedHelpArticles: "Related help articles",
	categories: "Categories",
	searchResults: "Search results",
	recentSearches: "Recent searches",
	clearAllRecentSearches: "Clear all recent",
	popularSearches: "Popular searches",
	suggestedQueries: "Suggested searches"
},
	"es-es": {
	searchPlaceholder: "Buscar",
	Products: "Productos",
	Designs: "Diseños",
	"Help Center": "Centro de ayuda",
	Inspiration: "Inspiración",
	PersonalizedResults: "Tus diseños",
	finishEditing: "Terminar de editar",
	reorder: "Volver a pedir",
	projects: "proyectos ({{{ numResults }}})",
	orders: "pedidos ({{{ numResults }}})",
	seeAll: "Ver todo",
	clearLabel: "Borrar",
	searchFlyoutLabel: "Existen {{numberOfResults}} sugerencias disponibles. Usa las flechas hacia arriba y abajo para navegar.",
	outOfStock: "Agotado",
	topSearches: "Búsquedas más frecuentes",
	loading: "Cargando…",
	yourRelatedProjects: "Tus {{{projectsAndCountToken}}} relacionados",
	yourRelatedOrders: "Tus {{{ordersAndCountToken}}} relacionados",
	yourRelatedProjectsAndOrders: "Tus {{{projectsAndCountToken}}} y {{{ordersAndCountToken}}} relacionados",
	topResults: "Resultados destacados",
	category: "Categoría",
	exploreAllResults: "Explorar todos los resultados",
	relatedDesigns: "Diseños relacionados",
	relatedHelpArticles: "Artículos de ayuda relacionados",
	categories: "Categorías",
	searchResults: "Resultados de búsqueda",
	recentSearches: "Búsquedas recientes",
	clearAllRecentSearches: "Eliminar todas las búsquedas recientes",
	popularSearches: "Búsquedas populares",
	suggestedQueries: "Búsquedas sugeridas"
},
	"es-us": {
	searchPlaceholder: "Buscar",
	Products: "Productos",
	Designs: "Diseños",
	"Help Center": "Centro de ayuda",
	Inspiration: "Inspiración",
	PersonalizedResults: "Sus diseños",
	finishEditing: "Terminar de editar",
	reorder: "Volver a pedir",
	projects: "proyectos ({{{ numResults }}})",
	orders: "pedidos ({{{ numResults }}})",
	seeAll: "Ver todo",
	clearLabel: "Borrar",
	searchFlyoutLabel: "Hay {{numberOfResults}} sugerencias disponibles. Usar las flechas hacia arriba y abajo para navegar.",
	outOfStock: "Agotado",
	topSearches: "Lo más buscado",
	loading: "Cargando...",
	yourRelatedProjects: "Sus {{{projectsAndCountToken}}} relacionados",
	yourRelatedOrders: "Sus {{{ordersAndCountToken}}} relacionados",
	yourRelatedProjectsAndOrders: "Sus {{{projectsAndCountToken}}} y {{{ordersAndCountToken}}} relacionados",
	topResults: "Los mejores resultados",
	category: "Categoría",
	exploreAllResults: "Explorar todos los resultados",
	relatedDesigns: "Diseños relacionados",
	relatedHelpArticles: "Artículos de ayuda relacionados",
	categories: "Categorías",
	searchResults: "Resultados de búsqueda",
	recentSearches: "Búsquedas recientes",
	clearAllRecentSearches: "Borrar todo lo reciente",
	popularSearches: "Búsquedas populares",
	suggestedQueries: "Sugerencias de búsqueda"
},
	"fi-fi": {
	searchPlaceholder: "Hae",
	Products: "Tuotteet",
	Designs: "Mallit",
	"Help Center": "Ohjekeskus",
	Inspiration: "Inspiraatiota",
	PersonalizedResults: "Omat mallisi",
	finishEditing: "Lopeta muokkaus",
	reorder: "Tilaa uudelleen",
	projects: "projektit ({{{ numResults }}})",
	orders: "tilaukset ({{{ numResults }}})",
	seeAll: "Näytä kaikki",
	clearLabel: "Läpinäkyvä",
	searchFlyoutLabel: "{{numberOfResults}} ehdotusta saatavilla. Liiku ylös- ja alaspäin osoittavilla nuolilla.",
	outOfStock: "Tilapäisesti lopussa",
	topSearches: "Suosituimmat haut",
	loading: "Ladataan...",
	yourRelatedProjects: "Tähän liittyvät {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Tähän liittyvät {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Tähän liittyvät {{{projectsAndCountToken}}} ja {{{ordersAndCountToken}}}",
	topResults: "Tärkeimmät tulokset",
	category: "Luokka",
	exploreAllResults: "Näytä kaikki tulokset",
	relatedDesigns: "Tähän liittyvät mallit",
	relatedHelpArticles: "Tähän liittyvät ohjeartikkelit",
	categories: "Kategoriat",
	searchResults: "Hakutulokset",
	recentSearches: "Äskettäiset haut",
	clearAllRecentSearches: "Tyhjennä kaikki äskettäiset",
	popularSearches: "Suosittuja hakuja",
	suggestedQueries: "Ehdotettuja hakuja"
},
	"fr-ca": {
	searchPlaceholder: "Rechercher",
	Products: "Produits",
	Designs: "Graphismes",
	"Help Center": "Centre d’assistance",
	Inspiration: "Idées",
	PersonalizedResults: "Vos graphismes",
	finishEditing: "Terminer les modifications",
	reorder: "Renouveler la commande",
	projects: "créations ({{{ numResults }}})",
	orders: "commandes ({{{ numResults }}})",
	seeAll: "Tout afficher",
	clearLabel: "Effacer",
	searchFlyoutLabel: "Il y a {{numberOfResults}} suggestions disponibles. Utilisez les flèches verticales ascendante et descendante pour naviguer.",
	outOfStock: "En rupture de stock",
	topSearches: "Recherches les plus fréquentes",
	loading: "Chargement en cours...",
	yourRelatedProjects: "Vos {{{projectsAndCountToken}}} connexes",
	yourRelatedOrders: "Vos {{{ordersAndCountToken}}} connexes",
	yourRelatedProjectsAndOrders: "Vos {{{projectsAndCountToken}}} et {{{ordersAndCountToken}}} connexes",
	topResults: "Meilleurs résultats",
	category: "Catégorie",
	exploreAllResults: "Explorer tous les résultats",
	relatedDesigns: "Graphismes connexes",
	relatedHelpArticles: "Articles d’aide connexes",
	categories: "Catégories",
	searchResults: "Résultats de recherche",
	recentSearches: "Recherches récentes",
	clearAllRecentSearches: "Effacer toutes les recherches récentes",
	popularSearches: "Recherches fréquentes",
	suggestedQueries: "Suggestions de recherches"
},
	"fr-fr": {
	searchPlaceholder: "Rechercher",
	Products: "Produits",
	Designs: "Graphismes",
	"Help Center": "Centre d’assistance",
	Inspiration: "Inspiration",
	PersonalizedResults: "Vos graphismes",
	finishEditing: "Terminer la modification",
	reorder: "Commander à nouveau",
	projects: "projets ({{{ numResults }}})",
	orders: "commandes ({{{ numResults }}})",
	seeAll: "Voir tout",
	clearLabel: "Effacer",
	searchFlyoutLabel: "Il y a {{numberOfResults}} suggestions disponibles. Utilisez les flèches haut et bas pour naviguer.",
	outOfStock: "En rupture de stock",
	topSearches: "Recherches populaires",
	loading: "En cours de chargement...",
	yourRelatedProjects: "Vos {{{projectsAndCountToken}}} associés",
	yourRelatedOrders: "Vos {{{ordersAndCountToken}}} associées",
	yourRelatedProjectsAndOrders: "Vos {{{projectsAndCountToken}}} et {{{ordersAndCountToken}}} associés",
	topResults: "Meilleurs résultats",
	category: "Catégorie",
	exploreAllResults: "Parcourir tous les résultats",
	relatedDesigns: "Graphismes associés",
	relatedHelpArticles: "Articles d’aide associés",
	categories: "Catégories",
	searchResults: "Résultats de la recherche",
	recentSearches: "Recherches récentes",
	clearAllRecentSearches: "Effacer les recherches récentes",
	popularSearches: "Recherches populaires",
	suggestedQueries: "Suggestions de recherche"
},
	"it-it": {
	searchPlaceholder: "Cerca",
	Products: "Prodotti",
	Designs: "Design",
	"Help Center": "Centro assistenza",
	Inspiration: "Ispirazione",
	PersonalizedResults: "I tuoi design",
	finishEditing: "Completa le modifiche",
	reorder: "Ripeti ordine",
	projects: "progetti ({{{ numResults }}})",
	orders: "ordini ({{{ numResults }}})",
	seeAll: "Vedi tutti",
	clearLabel: "Cancella",
	searchFlyoutLabel: "Ci sono {{numberOfResults}} suggerimenti disponibili. Usa le frecce per muoverti in alto o in basso.",
	outOfStock: "Non disponibile",
	topSearches: "Ricerche più popolari",
	loading: "Caricamento in corso...",
	yourRelatedProjects: "{{{projectsAndCountToken}}} correlato",
	yourRelatedOrders: "{{{ordersAndCountToken}}} correlato",
	yourRelatedProjectsAndOrders: "{{{projectsAndCountToken}}} e {{{ordersAndCountToken}}} correlati",
	topResults: "I migliori risultati",
	category: "Categoria",
	exploreAllResults: "Esplora tutti i risultati",
	relatedDesigns: "Design correlati",
	relatedHelpArticles: "Articoli di assistenza correlati",
	categories: "Categorie",
	searchResults: "Risultati di ricerca",
	recentSearches: "Ricerche recenti",
	clearAllRecentSearches: "Cancella tutti i dati recenti",
	popularSearches: "Ricerche popolari",
	suggestedQueries: "Ricerche consigliate"
},
	"nb-no": {
	searchPlaceholder: "Søk",
	Products: "Produkter",
	Designs: "Design",
	"Help Center": "Kundeservice",
	Inspiration: "Inspirasjon",
	PersonalizedResults: "Dine design",
	finishEditing: "Avslutte redigering",
	reorder: "Bestill på nytt",
	projects: "prosjekter ({{{ numResults }}})",
	orders: "bestillinger ({{{ numResults }}})",
	seeAll: "Vis alle",
	clearLabel: "Fjern",
	searchFlyoutLabel: "Det er {{numberOfResults}} forslag tilgjengelig. Bruk pilene opp og ned for å navigere.",
	outOfStock: "Utsolgt",
	topSearches: "Toppsøk",
	loading: "Laster ...",
	yourRelatedProjects: "Dine relaterte {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Dine relaterte {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Dine relaterte {{{projectsAndCountToken}}} og {{{ordersAndCountToken}}}",
	topResults: "Toppresultater",
	category: "Kategori",
	exploreAllResults: "Vis alle resultater",
	relatedDesigns: "Relaterte design",
	relatedHelpArticles: "Relaterte hjelpeartikler",
	categories: "Kategorier",
	searchResults: "Søkeresultater",
	recentSearches: "Nylige søk",
	clearAllRecentSearches: "Fjern alle nylige",
	popularSearches: "Populære søk",
	suggestedQueries: "Foreslåtte søk"
},
	"nl-nl": {
	searchPlaceholder: "Zoeken",
	Products: "Producten",
	Designs: "Ontwerpen",
	"Help Center": "Help",
	Inspiration: "Inspiratie",
	PersonalizedResults: "Jouw ontwerpen",
	finishEditing: "Bewerken voltooien",
	reorder: "Nabestellen",
	projects: "projecten ({{{ numResults }}})",
	orders: "bestellingen ({{{ numResults }}})",
	seeAll: "Alles bekijken",
	clearLabel: "Transparant",
	searchFlyoutLabel: "Er zijn {{numberOfResults}} suggesties beschikbaar. Gebruik de pijltjestoetsen naar boven en beneden om te navigeren.",
	outOfStock: "Niet op voorraad",
	topSearches: "Meest gezocht",
	loading: "Bezig met laden...",
	yourRelatedProjects: "Jouw gerelateerde {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Jouw gerelateerde {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Jouw gerelateerde {{{projectsAndCountToken}}} en {{{ordersAndCountToken}}}",
	topResults: "Beste resultaten",
	category: "Categorie",
	exploreAllResults: "Bekijk alle resultaten",
	relatedDesigns: "Gerelateerde ontwerpen",
	relatedHelpArticles: "Gerelateerde helpartikelen",
	categories: "Categorieën",
	searchResults: "Zoekresultaten",
	recentSearches: "Recente zoekopdrachten",
	clearAllRecentSearches: "Wis alle recente",
	popularSearches: "Populaire zoekopdrachten",
	suggestedQueries: "Voorgestelde zoekopdrachten"
},
	"pt-pt": {
	searchPlaceholder: "Procurar",
	Products: "Produtos",
	Designs: "Designs",
	"Help Center": "Centro de Ajuda",
	Inspiration: "Inspiração",
	PersonalizedResults: "Os seus designs",
	finishEditing: "Concluir a edição",
	reorder: "Voltar a encomendar",
	projects: "projetos ({{{ numResults }}})",
	orders: "encomendas ({{{ numResults }}})",
	seeAll: "Ver tudo",
	clearLabel: "Limpar",
	searchFlyoutLabel: "Há {{numberOfResults}} sugestões disponíveis. Utilize as setas para cima e para baixo para navegar.",
	outOfStock: "Esgotado",
	topSearches: "Principais pesquisas",
	loading: "A carregar...",
	yourRelatedProjects: "Os seus {{{projectsAndCountToken}}} relacionados",
	yourRelatedOrders: "Os seus {{{ordersAndCountToken}}} relacionados",
	yourRelatedProjectsAndOrders: "Os seus {{{projectsAndCountToken}}} e as suas {{{ordersAndCountToken}}} relacionados",
	topResults: "Principais resultados",
	category: "Categoria",
	exploreAllResults: "Explorar todos os resultados",
	relatedDesigns: "Designs relacionados",
	relatedHelpArticles: "Artigos de ajuda relacionados",
	categories: "Categorias",
	searchResults: "Resultados da pesquisa",
	recentSearches: "Pesquisas recentes",
	clearAllRecentSearches: "Limpar todas as recentes",
	popularSearches: "Pesquisas populares",
	suggestedQueries: "Sugestões de pesquisa"
},
	"sv-se": {
	searchPlaceholder: "Sök",
	Products: "Produkter",
	Designs: "Designer",
	"Help Center": "Hjälpcenter",
	Inspiration: "Inspiration",
	PersonalizedResults: "Dina designer",
	finishEditing: "Slutför redigering",
	reorder: "Efterbeställ",
	projects: "projekt ({{{ numResults }}})",
	orders: "beställningar ({{{ numResults }}})",
	seeAll: "Visa alla",
	clearLabel: "Rensa",
	searchFlyoutLabel: "Det finns {{numberOfResults}} förslag. Använd uppåt- och nedåtpilarna för att navigera.",
	outOfStock: "Ej i lager",
	topSearches: "Vanligaste sökningarna",
	loading: "Läser in ...",
	yourRelatedProjects: "Relaterade {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Relaterade {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Relaterade {{{projectsAndCountToken}}} och {{{ordersAndCountToken}}}",
	topResults: "Toppresultat",
	category: "Kategori",
	exploreAllResults: "Utforska alla resultat",
	relatedDesigns: "Liknande designer",
	relatedHelpArticles: "Liknande hjälpartiklar",
	categories: "Kategorier",
	searchResults: "Sökresultat",
	recentSearches: "Nyligen gjorda sökningar",
	clearAllRecentSearches: "Rensa allt nyligt",
	popularSearches: "Populära sökningar",
	suggestedQueries: "Förslag på sökningar"
}
};

export { translations as default };
//# sourceMappingURL=translations.json.js.map
